import { createContext, useContext, useState } from "react";

const DICT = {
  "Carte & Salles": "Map & Venues", "Coachs": "Coaches", "Comment ça marche": "How it works", "Connexion": "Log in", "Inscription": "Sign up",
  "Tableau de bord": "Dashboard", "Déconnexion": "Log out",
  "Des salles libres. Des coachs motivés. Zéro engagement.": "Free venues. Motivated coaches. Zero commitment.",
  "TymCoach connecte les créneaux inutilisés des salles de sport aux coachs et aux particuliers qui veulent bouger — à la séance, sans abonnement.": "TymCoach connects unused time slots in gyms and studios with coaches and people who want to train — per session, no membership.",
  "Voir la carte": "See the map", "Créer un compte": "Create an account",
  "Une contingence devient une opportunité.": "A constraint becomes an opportunity.",
  "Prêt à essayer sans engagement ?": "Ready to try with no commitment?",
  "Créez votre compte gratuitement et découvrez la carte des salles et coachs près de chez vous.": "Create your free account and discover venues and coaches near you.",
  "Salles & créneaux disponibles": "Available venues & slots", "Coachs disponibles": "Available coaches",
  "Découvrez les coachs adhérents à la plateforme, prêts à réserver une salle près de chez vous.": "Meet the coaches on the platform, ready to book a venue near you.",
  "Toutes disciplines": "All disciplines", "Toutes villes": "All cities", "Disponible aujourd'hui": "Available today", "Réinitialiser": "Reset",
  "Voir le profil": "View profile", "Voir les créneaux": "See slots", "Tous équipements": "All equipment", "Toute la journée": "All day",
  "Créneaux libres": "Free slots", "Adresse, ville, quartier…": "Address, city, district…", "Autour de moi": "Around me",
  "Se connecter": "Log in", "Créer mon compte": "Create my account", "Email": "Email", "Mot de passe": "Password", "Nom complet": "Full name",
  "Réserver": "Book", "Ajouter aux favoris": "Add to favourites", "Favorite": "Favourite", "Avis": "Reviews", "Communauté": "Community",
  "Voir les créneaux et réserver": "See slots and book", "Je suis coach, je veux m'entraîner ici": "I'm a coach, I want to train here",
  "Planning en direct": "Live schedule", "Coachs partenaires": "Partner coaches", "Informations légales": "Legal information",
};

const I18nContext = createContext({ lang: "fr", t: (s) => s, setLang: () => {} });

export const detectLang = () => {
  const saved = localStorage.getItem("sc_lang");
  if (saved) return saved;
  return (navigator.language || "fr").toLowerCase().startsWith("en") ? "en" : "fr";
};

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(detectLang);
  const setLang = (l) => { localStorage.setItem("sc_lang", l); setLangState(l); document.documentElement.lang = l; };
  const t = (s) => (lang === "en" ? DICT[s] || s : s);
  return <I18nContext.Provider value={{ lang, t, setLang }}>{children}</I18nContext.Provider>;
}

export const useI18n = () => useContext(I18nContext);

export function LangSwitch() {
  const { lang, setLang } = useI18n();
  return (
    <div className="flex items-center rounded-full border border-slate-200 bg-white text-xs font-semibold overflow-hidden" data-testid="lang-switch">
      {["fr", "en"].map((l) => (
        <button key={l} data-testid={`lang-${l}`} onClick={() => setLang(l)} className={`px-2.5 py-1 uppercase ${lang === l ? "bg-slate-900 text-white" : "text-slate-600 hover:bg-slate-100"}`}>{l}</button>
      ))}
    </div>
  );
}
